module.exports = __webpack_public_path__ + "img/020084.2575a9d9.png";